import { Component, OnInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $('.inner-item').click(() => {
      this.hideMenu();
    });
  }

  private hideMenu(): void {
    if ($('#navbarResponsive').hasClass('show')) {
      $('#navbarResponsive').removeClass('show');
    }
  }

}
